import { LinkButton } from "@/components/LinkButton";
import { Heading } from "@/components/heading/Heading";
import { HeadingSection } from "@/components/heading/HeadingSection";
import { CompactNotesSection } from "@/features/notes/CompactNotesSection";
import { useActiveProject } from "@/features/project/ActiveProject";
import { ProjectDetailsTabs } from "@/features/project/ProjectDetailsTabs";
import { ProjectDetails } from "@/features/projects/cards/ProjectDetails";
import { Loading } from "@repo/skapa";
import { t } from "@repo/translation";
import {
  CustomerCardWrapper,
  ElementsContainer,
  Line,
  ModalSheet,
  RegionContainer,
  SectionContainer,
} from "@repo/ui";
import { trackAnalytics } from "@repo/utils";

interface QuickviewProps {
  opportunityId: number | undefined;
  closeQuickView: () => void;
}

export const Quickview = ({
  opportunityId,
  closeQuickView,
}: QuickviewProps) => {
  const { opportunity, isValidating } = useActiveProject();

  return (
    <ModalSheet
      title={t("label.project_details")}
      visible={opportunityId !== undefined}
      onClose={closeQuickView}
      footer={
        <LinkButton
          to={`/opportunity/${opportunityId}`}
          type="primary"
          text={t("action.manage")}
          onClick={() => {
            trackAnalytics("open_project_page");
          }}
        />
      }
    >
      {isValidating && <Loading text={t("prompt.loading")} />}
      {opportunity && (
        <HeadingSection value={3}>
          <RegionContainer>
            <SectionContainer>
              <Heading textStyle="Heading.M">
                {opportunity?.title ?? ""}
              </Heading>
              <ProjectDetails editable={false} opportunity={opportunity} />
              <Line />
              <ElementsContainer>
                <HeadingSection>
                  <Heading textStyle="Heading.S">
                    {t("label.customer_details")}
                  </Heading>
                </HeadingSection>

                <CustomerCardWrapper
                  editable={false}
                  projectId={opportunityId}
                />
              </ElementsContainer>
              <Line />
              <ProjectDetailsTabs opportunity={opportunity} />
              <Line />
              <CompactNotesSection opportunity={opportunity} />
            </SectionContainer>
          </RegionContainer>
        </HeadingSection>
      )}
    </ModalSheet>
  );
};
